import { useContext, useEffect, useState } from "react"
import { Card, Col, Row } from "react-bootstrap"
import { BsPlusCircleFill } from "react-icons/bs"
import { Link } from "react-router-dom"
import Get from "../../api/Get"
import { CORREOS_DELETE, CORREOS_LIST } from "../../api/Routes"
import { authContext } from "../../context/AuthContext"
import TableSearch from "../../components/TableSearch"
import { FaPen } from "react-icons/fa"
import { MdDeleteSweep } from "react-icons/md"
import LoadingList from "../../loader/LoadingList"
import ModalDelete from "../../components/ModalDelete"
import Delete from "../../api/Delete"
import { withTranslation } from "react-i18next"
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever"

function CorreosList({t, url}){
    const [loading, setLoading] = useState(true)
    const {auth} = useContext(authContext)
    const [items, setItems] = useState([])
    const [showDelete, setShowDelete] = useState(false)
    const [idDelete, setIdDelete] = useState(null)
    const [isDeleting, setIsDeleting] = useState(false)
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)


    useEffect(()=>{
        setLoading(true)
        Get({url: CORREOS_LIST, access_token: auth.data.access_token})
        .then(response=>{
            setItems(response.data.data.response.content)
            setLoading(false)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }, [])

    const actions = (cell, row, index) => {        
        return (
            <div>
                <ul className="list-inline mb-0">
                    <li className="list-inline-item"><Link to={`${url}/crear?id=${row.id}`}><FaPen className='iconAction colorNaranja' /></Link></li>                   
                    <li className="list-inline-item cursor-pointer"><MdDeleteSweep className='iconAction colorRojo' 
                        onClick={e=>{
                            setIdDelete(row.id)
                            setShowDelete(true)
                        }} /></li>
                </ul>          
            </div>
        );
    }

    const onHandleDelete = () =>{
        setIsDeleting(true)
        Delete({url: `${CORREOS_DELETE}/${idDelete}`, access_token: auth.data.access_token})
        .then(response=>{
            let arr = items.filter(el=>el.id!==idDelete)
            setItems(arr)
            setIsDeleting(false)
            setShowDelete(false)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, 
        {
            dataField: 'name',
            text: 'NOMBRE',
            headerStyle: { width: '90%' },
        },
        {
            dataField: '',
            isDummyField: true,
            text: 'ACCIONES',
            style:{
                textAlign: 'center'
            },
            headerStyle: { width: '10%', textAlign: 'center' },
            formatter: actions,            
        }
    ]


    return (
        <>
            {loading && <LoadingList />}
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">Correos</h2>
                </Col>
                <Col xs="12" md="4">
                    <Row className="align-items-center">                        
                        <Col className="text-right">
                            <Link to={`${url}/crear`}><BsPlusCircleFill className="add-btn"/></Link>                        
                        </Col>
                    </Row>                
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card className="shadow-1 mt-3">
                        <Card.Body>                            
                            <TableSearch columns={columns} items={items}/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalDelete 
                showDelete={showDelete} 
                onHandleDelete={onHandleDelete} 
                setShowDelete={setShowDelete}
                isDeleting={isDeleting}
            />
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
    )
}

export default withTranslation()(CorreosList)